import { createFileRoute } from '@tanstack/react-router';
import { RegistrationSuccessPage } from '@pages/registration-success';

/** Route fur die Anmeldung-Bestatigung (/registration-success). */
export const Route = createFileRoute('/registration-success')({
  component: RegistrationSuccessPage,
});
